import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from 'utils/auth'
import {captivePortalFilterReducer, captivePortalUsersReducer, loadStoreOptionsReducer} from './models/captivePortal'

export default (store) => ({
  path: 'captive-portal',
  onEnter: isLoggedIn(store),
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      const CaptivePortalDetails = require('./containers/CaptivePortal').default
      // const {
      //   captivePortalFilterReducer,
      //   loadStoreOptionsReducer, captivePortalReducer
      // } = require('./models/CaptivePortal')
      injectReducer(store, {key: 'captivePortalFilter', reducer: captivePortalFilterReducer})
      // injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'captivePortalUsers', reducer: captivePortalUsersReducer})
      /*  Return getComponent   */
      cb(null, CaptivePortalDetails)

      /* Webpack named bundle   */
    }, 'CaptivePortal')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CaptivePortal/index.js